import React from 'react';

import twMerge from 'utilities/src/twMerge';

import IconComponent from 'ui/src/components/Icon';

import { MobileHeaderToggleProps } from './_props';

import useMobileHeaderTheme from './themes';

/**
 * MobileHeaderToggle Component
 */

function MobileHeaderToggle({
  isMobileMenuOpen,
  toggleMobileMenu,
  iconSize = 'IconM',
  iconClasses,
}: MobileHeaderToggleProps) {
  const { mobileHeaderIconToggleClasses } = useMobileHeaderTheme();

  return (
    <button type="button" className={mobileHeaderIconToggleClasses} onClick={toggleMobileMenu} aria-label="toggle">
      <IconComponent
        iconName={isMobileMenuOpen ? 'Close' : 'Menu'}
        size={iconSize}
        className={twMerge('bg-site-neutrals-900', iconClasses)}
      />
    </button>
  );
}

/**
 * Exports
 */

export default MobileHeaderToggle;
